var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMeetingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M18.889 17.778h-1.111V2.222c0-.61-.5-1.11-1.111-1.11h-4.445c0-.612-.5-1.112-1.11-1.112H3.332c-.61 0-1.11.5-1.11 1.111v16.667H1.11c-.611 0-1.111.5-1.111 1.11C0 19.5.5 20 1.111 20h10c.611 0 1.111-.5 1.111-1.111V3.333h3.334V18.89c0 .611.5 1.111 1.11 1.111h2.223C19.5 20 20 19.5 20 18.889s-.5-1.111-1.111-1.111m-10-6.667c-.611 0-1.111-.5-1.111-1.111s.5-1.111 1.11-1.111C9.5 8.889 10 9.389 10 10s-.5 1.111-1.111 1.111"
})));
export { SvgMeetingIcon as ReactComponent };
export default __webpack_public_path__ + "551e014ad7b660e91a6afe467dea5852.svg";